<template>
    <div class="photo-container">
        <input id="input-file-image" type="file" @change="addPhoto" accept=".png,.jpg,.jpeg,.heic" />
        <img v-if="photo" :src="photo" />
        <div v-if="!photo" class="element-button-photo" :style="$parent.config.photosStyles">
            <i v-if="!$parent.config.addPhotoString" class="fa fa-plus"></i>
            <span v-if="!$parent.config.addPhotoString">
                {{ $parent.str['add_photo'] }}
            </span>
            <span v-if="$parent.config.addPhotoString">
                {{ $parent.config.addPhotoString }}
            </span>
        </div>
    </div>
</template>
<style scoped>
.photo-container {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}

.photo-container input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 7;
    opacity: 0;
}

.photo-container button svg {
    margin-right: 10px;
}

.photo-container img {
    width: 300px;
    max-width: 300px;
}

.element-button-photo {
    width: 100%;
    max-width: 200px;
    margin: 0 auto;
    height: 100px;
    border: 1px solid #fff;
    border-radius: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.element-button-photo svg {
    margin-right: 7px;
}
</style>
<script>
import StorageApi from '../services/StorageApi'
import Utils from '../services/Utils'

export default {
    name: 'photo',
    props: ['callback', 'argument', 'photo', 'size'],
    data() {
        return {
            imageMaxSize: this.getImageSize(),
        }
    },
    methods: {
        getImageSize: function () {
            if (this.size) {
                return this.size
            }
            if (this.$parent.config && this.$parent.config.imageSize) {
                return this.$parent.config.imageSize
            }
            return 800
        },
        addPhoto: function (event) {
            const self = this
            let file = event.srcElement.files[0]
            event.target.value = ''

            if (file.type.indexOf('heic') > -1) {
                convertHeicToJpg()
            } else {
                file.localUrl = URL.createObjectURL(file)
                getImageBase64()
            }

            function convertHeicToJpg() {
                self.$isLoading(true)
                StorageApi.convertImageHeicToPng(file, function (response) {
                    self.$isLoading(false)
                    if (response.success) {
                        file.localUrl = response.data.png_file
                        getImageBase64()
                    } else {
                        self.$alert(response.message, '', 'warning', Utils.getAlertOptions())
                    }
                })
            }

            function getImageBase64() {
                const image = new Image()
                image.src = file.localUrl
                image.onerror = function () {
                    self.$alert(self.$parent.str['invalid_image_format'] + ' ' + file.type, '', 'warning', Utils.getAlertOptions())
                }
                image.onload = function () {
                    self.callback(resizeImage(image), self.argument)
                }

                function resizeImage(image) {
                    const canvas = document.createElement('canvas')
                    let width = image.width
                    let height = image.height
                    if (self.imageMaxSize !== 'no_resize') {
                        if (width > height) {
                            if (width > self.imageMaxSize) {
                                height *= self.imageMaxSize / width
                                width = self.imageMaxSize
                            }
                        } else {
                            if (height > self.imageMaxSize) {
                                width *= self.imageMaxSize / height
                                height = self.imageMaxSize
                            }
                        }
                    }
                    canvas.width = width
                    canvas.height = height
                    const ctx = canvas.getContext('2d')
                    ctx.drawImage(image, 0, 0, width, height)
                    return canvas.toDataURL()
                }
            }
        },
    },
}
</script>
